export const faxConstant = {
    SEND_REQUEST: 'FAX_SEND_REQUEST',
    QUEUE_PRESCRIPTION_FAX_SUCCESS: 'FAX_QUEUE_PRESCRIPTION_FAX_SUCCESS',
    QUEUE_SLEEP_ASSESSMENT_FAX_SUCCESS: 'FAX_QUEUE_SLEEP_ASSESSMENT_FAX_SUCCESS'
};
